import React from "react";
import { NavLink } from "react-router-dom";
import "./style.css";

const FloatingMenu = () => {
  return (
    <div className="floating-menu">
      <NavLink
        to="/principal"
        className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
      >
        <i className="fas fa-home"></i>
        <span>Início</span>
      </NavLink>
      <NavLink
        to="/humor"
        className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
      >
        <i className="fas fa-smile-beam"></i>
        <span>Humor</span>
      </NavLink>
      <NavLink
        to="/mochila"
        className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
      >
        <i className="fa-solid fa-sack-dollar"></i>
        <span>Mochila</span>
      </NavLink>
      <NavLink
        to="/lojinha"
        className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
      >
        <i className="fa-solid fa-cart-shopping"></i>
        <span>Lojinha</span>
      </NavLink>
    </div>
  );
};

export default FloatingMenu;
